import NavBar from './NavBar.js';

export default NavBar
